import Phaser from 'phaser';
import { LevelSelectScene } from '@/scenes/LevelSelectScene.ts';
import { GameScene } from '@/scenes/GameScene.ts';
import { Level1Scene } from '@/levels/scenes/Level1Scene.ts';
import { Level2Scene } from '@/scenes/Level2Scene.ts';
import { Level3Scene } from '@/scenes/Level3Scene.ts';
import { Level4Scene } from '@/levels/scenes/Level4Scene.ts';
import { Level5Scene } from '@/levels/scenes/Level5Scene.ts';
import { Level6Scene } from '@/levels/scenes/Level6Scene.ts';
import { Level7Scene } from '@/levels/scenes/Level7Scene.ts';
import { Level8Scene } from '@/levels/scenes/Level8Scene.ts';
import { Level9Scene } from '@/levels/scenes/Level9Scene.ts';
import { Level10Scene } from '@/levels/scenes/Level10Scene.ts';
import { Level11Scene } from '@/levels/scenes/Level11Scene.ts';
import { Level12Scene } from '@/levels/scenes/Level12Scene.ts';
import { Level13Scene } from '@/levels/scenes/Level13Scene.ts';
import { Level14Scene } from '@/levels/scenes/Level14Scene.ts';
import { Level15Scene } from '@/levels/scenes/Level15Scene.ts';
import { Level16Scene } from '@/levels/scenes/Level16Scene.ts';
import { Level17Scene } from '@/levels/scenes/Level17Scene.ts';
import { Level18Scene } from '@/levels/scenes/Level18Scene.ts';
import { Level19Scene } from '@/levels/scenes/Level19Scene.ts';
import { Level20Scene } from '@/levels/scenes/Level20Scene.ts';

const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 800,
  height: 600,
  parent: 'game-container',
  backgroundColor: '#1a1a2e',
  scene: [
    LevelSelectScene,
    GameScene,
    Level1Scene,
    Level2Scene,
    Level3Scene,
    Level4Scene,
    Level5Scene,
    Level6Scene,
    Level7Scene,
    Level8Scene,
    Level9Scene,
    Level10Scene,
    Level11Scene,
    Level12Scene,
    Level13Scene,
    Level14Scene,
    Level15Scene,
    Level16Scene,
    Level17Scene,
    Level18Scene,
    Level19Scene,
    Level20Scene,
  ],
};

new Phaser.Game(gameConfig);